import {Card} from '@atoms';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  border: ${({theme}) => `1px solid ${theme.divider.grey}`};
`;
